import React, { useCallback, useContext, useEffect, useState } from "react";

import { FieldOption } from "@safetyculture/s12-apis-connect-web/s12/typefield/v1/field_pb";
import {
  Field,
  ListFieldsRequest,
} from "@safetyculture/s12-apis-connect-web/s12/users/userfield/v1/field_pb";

import { listFields } from "../../../../api/endpoints/user-field";
import { callOptionsHeaders } from "../../../../api/helpers";
import {
  GrpcError,
  SnackbarContext,
} from "../../../../context/snackbar-context";

type SelectTypeProps = {
  values: string[];
  fieldId: string;
  roleId: string;
  regionCode: string;
};

export const SelectType = (props: SelectTypeProps) => {
  const { showError } = useContext(SnackbarContext);
  const [field, setField] = useState<Field | undefined>();
  const [isLoading, setIsLoading] = useState(true);

  const loadField = useCallback(
    async (fieldId: string) => {
      setIsLoading(true);
      try {
        const req = new ListFieldsRequest({
          orgId: props.roleId,
        });
        const fields = await listFields(
          req,
          callOptionsHeaders(props.regionCode, props.roleId),
        );
        setField(fields?.find((field) => field.id === fieldId));
      } catch (e) {
        showError(e as GrpcError);
      } finally {
        setIsLoading(false);
      }
    },
    [props.roleId, props.regionCode, showError],
  );

  useEffect(() => {
    loadField(props.fieldId);
  }, [loadField, props.fieldId]);

  if (isLoading) {
    return <div>Loading...</div>;
  }

  if (!field) {
    return <div>Field not found</div>;
  }

  if (props.values.length > 1) {
    return (
      <ul style={{ textAlign: "left", paddingLeft: 0 }}>
        {props.values.map((value) => (
          <li data-anchor="user-attribute-select" key={value}>
            {getOptionLabel(field.selectOptions, value)}
          </li>
        ))}
      </ul>
    );
  }
  return (
    <div data-anchor="user-attribute-select">
      {getOptionLabel(field.selectOptions, props.values[0])}
    </div>
  );
};

const getOptionLabel = (fieldOptions: FieldOption[], value: string) => {
  const option = fieldOptions.find((option) => option.id === value);
  return option ? option.label : value;
};
